// extracted by mini-css-extract-plugin
export default {"professionalContainer":"styles_professionalContainer__KMaV8","containerTitle":"styles_containerTitle__zesuV","cardsContainer":"styles_cardsContainer__BYI7u"};